import {Base, model, endpoint, belongsTo, hasMany} from '@scoutgg/ftw/source/lib/model'

@model('Team')
@endpoint('teams', {root: '/api'})
@belongsTo('seasonSource')
@hasMany('players')
export class Team extends Base {
  get short() {
    if(this.abbr) return this.abbr
    if(!this.name) return '???'
    return this.name.slice(0, 3).toUpperCase()
  }
  get iconUrl() {
    if(!this.icon) {
      return 'https://statcenter.scoutgg.net/s3/uploads/assets/team_logo_placeholder.svg'
    }
    return `https://statcenter.scoutgg.net/s3/uploads/assets/${this.icon}`
  }
}
